export default {
  title: '会员列表',
  nickname: '昵称',
  nicknamePlaceholder: '请输入昵称',
  level: '会员等级',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  phone: '手机号',
  phonePlaceholder: '请输入手机号',
  country: '所在国家',
  columns: {
    id: 'ID',
    nickname: '会员昵称',
    level: '会员等级',
    country: '所在国家',
    email: '邮箱',
    phone: '手机号',
    registerTime: '注册时间',
  },
  actions: {
    detail: '详情',
    givePoints: '送积分',
    giveGrowth: '送成长值',
  },
  detail: {
    growthProgress: '成长值',
    growthHint: '距离下一级 {next} 还需 {remain} 成长值',
    baseInfo: '基础信息',
    editProfile: '编辑资料',
    blacklist: '加入黑名单',
    asset: '资产信息',
    currentPoints: '当前积分',
    viewDetail: '查看明细',
    redPacketAmount: '红包金额',
    scanStat: '扫码统计',
    firstScanDate: '首次扫码日期',
    lastScanTime: '最近扫码时间',
    scanCount: '扫码个数',
    tags: '标签画像',
    manageTags: '管理标签',
    genderUnknown: '未知',
    genderMale: '男',
    genderFemale: '女',
    fields: {
      nickname: '昵称',
      memberNo: '会员编号',
      realName: '真实姓名',
      gender: '性别',
      country: '国家',
      phone: '手机号',
      email: '邮箱',
      wechat: '微信号',
      birthday: '生日',
      lastLogin: '最后登录时间',
      registerTime: '注册时间',
    },
  },
  modal: {
    codeRecord: {
      title: '扫码明细',
      codeId: '码ID',
      scanResult: '扫码结果',
      scanTime: '扫码时间',
      scanRegion: '扫码地区',
    },
    pointsRecord: {
      title: '积分明细',
      type: '类型',
      dateRange: '日期范围',
      totalPoints: '累计积分',
      consumedPoints: '已消耗积分',
      availablePoints: '可用积分',
      source: '积分来源',
      typeColumn: '类型',
      amount: '数量',
      date: '日期',
      income: '收入',
      expense: '支出',
    },
    redPacketRecord: {
      title: '红包明细',
      type: '类型',
      amount: '金额',
      id: '红包ID',
      status: '状态',
      channel: '发放渠道',
      source: '红包来源',
      receivedTime: '领取时间',
    },
    givePoints: {
      titlePoints: '送积分',
      titleGrowth: '送成长值',
      points: '积分',
      growth: '成长值',
      amountPlaceholder: '请输入数量（支持负数）',
      amountHint: '输入正数为发放，负数为扣减',
      amountRequired: '请输入数量',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
    },
    blacklist: {
      title: '加入黑名单',
      confirmTitle: '确认将该会员加入黑名单？',
      warning: '加入黑名单后，该会员将无法再扫码、领取红包及参与活动。',
      tip: '此操作可在「黑名单管理」中移除。',
    },
  },
};
